<template>
  <div :class="`o-channel o-block-link ${channel.id}`"
    @click="openChannel(channel.id)"
    :style="{ color: `${channel.textColor}`, backgroundColor: `${channel.backgroundColor}`, backgroundImage : `url(${channel.backgroundImage})`}" >
    <div class="o-channel__logo"><img :src="channel.img" class="o-channel__img" width="70" height="70" alt="" /></div>
    <div v-if="channel.lastPlay" class="o-channel__content">
      <div class="o-channel__title">{{channel.lastPlay.title}}</div>
      <div class="o-channel__artist">{{channel.lastPlay.artist.name}}</div>
    </div>
    <Play class="o-channel__action" :channel="channel.id" v-on:play="on-play" data-action="open-radioplayer" data-position="stationList" :data-station-id="channel.id" />
  </div>
</template>

<script>
import { openPlayer } from '../../mixins/radioPlayer';
import Play from './Play';

export default {
  name: 'ChannelListItem',
  components: {
    Play,
  },
  props: [
    'channel',
  ],
  mixins: [openPlayer],
};
</script>
